import {Component, computed, ElementRef, inject, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DataGridView, DataGridViewCollumn, Types} from '../../../Componente/DataGridView';
import {PhoneCall} from '../../../Componente/PhoneCall';
import {PopUpView} from '../../../Componente/PopUpView';
import {FloatingButtonComponent} from '../../../Componente/floatingButton';
import {DateSelect} from '../../../Akte/Controlls/DateSelect';
import {StatusPipe} from '../../../Pipes/StatusPipe';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';
import {PGFilterService} from '../../Services/PGFilterService';
import {ToastService} from '../../../Akte/Services/Toasts/ToastService';
import {AktePopup} from '../Status/AktePopup';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {StatusModel} from '../../../Api/DcoApi/Status/StatusModel';
import {AustauschModel} from '../../../Api/DcoApi/Austausch/AustauschModel';
import {SelectSerial} from './Popups/select-serial/select-serial';
import {VersandService} from '../../Services/VersandService';
import {DhlControlls} from '../Versand/Controlls/dhl-controlls/dhl-controlls';

@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, PhoneCall,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, StatusPipe, VersandStepper, DhlControlls
  ],
  selector: 'Austausch',
  templateUrl: './Austausch.html',
  standalone: true,
  styleUrl: './Austausch.css'
})
export class Austausch{
  dataurl = computed(() => { return `/Backend/Api/V2/Austausch/${this.pgService.PG()}` })
  private modalService = inject(NgbModal);
  @ViewChild('Grid') childComponent!: DataGridView<StatusModel>;
  VersandService : VersandService = inject(VersandService);
  @ViewChildren('VersandCbx') checkboxElements!: QueryList<ElementRef<HTMLInputElement>>;

  selectedIDs: AustauschModel[] = [];

  constructor(public pgService: PGFilterService) {


  }
  async Export(versand: boolean = true) {

    var ids = this.selectedIDs.map(o => o.key);


    if(versand)
      ids = this.selectedIDs.filter(o => o.geraetSeriennummerNeu && o.geraetSeriennummerNeu != '').map(o => o.key);


    await this.VersandService.DownloadMultiPart(`/Backend/Api/V2/VersandAuftraege/MassSendBySelection/File`, ids, versand);
    this.selectedIDs = [];
    this.triggerReload();
  }
  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  addOrRemoveID(key: AustauschModel) {
    var entry = this.selectedIDs.find(o => o.key == key.key);

    if (entry) {
      this.selectedIDs = this.selectedIDs.filter(o =>  o.key != key.key)
    }
    else {
      this.selectedIDs.push(key);
    }
  }

  OpenAkte(row: AustauschModel) {
    var modal = this.modalService.open(AktePopup)
    modal.componentInstance.Key = row.key;
    modal.componentInstance.versichertenNr = row.versicherungsId;
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  SetSerial(row: AustauschModel) {
    var modal = this.modalService.open(SelectSerial)
    modal.componentInstance.Auftrag = row.versandAuftrag;
    modal.componentInstance.Tausch = !(!row.geraetSeriennummerNeu || row.geraetSeriennummerNeu == '');
    modal.update({ size: 'Dialog' });
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  async InitTracking(item: StatusModel, Versand:boolean = true) {

    var key  = Versand ? item.versandAuftrag : item.retourenAuftrag;
    if(key)
      await this.VersandService.InitTracking(key);
    else
      await this.VersandService.InitTrackingForOrder(item.key, Versand);
    this.triggerReload();
  }

  SelectAll() {
    this.checkboxElements.forEach((checkboxRef: ElementRef<HTMLInputElement>) => {
      const checkbox = checkboxRef.nativeElement;

      // 3. Only target them if they match your specific class
      if (checkbox.classList.contains('VersandCbx')) {

        // Force the check state to true if it isn't already
        if (!checkbox.checked) {
          checkbox.checked = true;

          // 4. CRITICAL: Manually dispatch the change event
          // This forces Angular to run your (change)="onCheckboxChange(...)" function!
          checkbox.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  hasTracking(Tracking:string): boolean {
    return Tracking != null && Tracking != '';
  }

  OpenAkteNew() {
    var modal = this.modalService.open(AktePopup)
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  async openSendDialog(model: StatusModel, isVersand: boolean = false) {

    await this.VersandService.openSendDialog( (isVersand ? model.versandTracking : model.retourenTracking) ?? "", model.versichertenMail ?? "",isVersand)
    this.triggerReload();
  }


  protected readonly Types = Types;
}
